import { DataCellProps } from '../types';
import { renderChips } from 'utils';

export const TenantTagsCell = ({ _customRowProps, tenant }: DataCellProps) => {
  const tenantTagsList = tenant.tags;
  return <div>{renderChips(tenantTagsList, 2)}</div>;
};
